import { connectMediaStore } from './withOwnReduxStore';
import { getAllowedDeviationTypes, getAllowGifs, getAllowPremium, getAllowMature, getIgnoreDeviationIds, getMinDeviationWidth, getMinDeviationHeight, } from '../selectors';
export default connectMediaStore(function (state) { return ({
    allowedDeviationTypes: getAllowedDeviationTypes(state),
    allowGifs: getAllowGifs(state),
    allowPremium: getAllowPremium(state),
    allowMature: getAllowMature(state),
    ignoreDeviationIds: getIgnoreDeviationIds(state),
    minDeviationWidth: getMinDeviationWidth(state),
    minDeviationHeight: getMinDeviationHeight(state),
}); });
//# sourceMappingURL=withFilter.js.map